import { render, staticRenderFns } from "./booking_requests.vue?vue&type=template&id=16650e90&scoped=true"
import script from "./booking_requests.vue?vue&type=script&lang=js"
export * from "./booking_requests.vue?vue&type=script&lang=js"
import style0 from "./booking_requests.vue?vue&type=style&index=0&id=16650e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16650e90",
  null
  
)

export default component.exports